import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { endPoints } from "api/endPoints";
import { RootState } from "store/rootReducer";
import { get} from "services/api.service";

const intialState: any = {
    loading: false,
    error: false,
    status: 'pending',
    data: null
}

export const getAnalyticsData: any = createAsyncThunk(
    "getAnalyticsData", async (payload: any, { rejectWithValue }) => {
        const {from, to} = payload;
        try {
            const response: any = await get(`${endPoints.DASHBOARD.ANALYTICS}?start_date=${from}&end_date=${to}`);
            return response.data;
        } catch (e:any) {
            return rejectWithValue(e.response.data);
        }
    })


const getAnalyticsSlice = createSlice({
    name: 'getAnalyticsData',
    initialState: intialState,
    reducers: {
        clearState: (state) => {
            return intialState;
        },
    },
    extraReducers: {
        [getAnalyticsData.rejected]: (state, { payload }) => {
            state.loading = false;
            state.error = true;
        },
        [getAnalyticsData.pending]: (state) => {
            state.loading = true;
        },
        [getAnalyticsData.fulfilled]: (state, { payload }) => {
            state.loading = false;
            state.data = payload.data;
            state.status = "fulfilled";
        }
    }
});

export const { clearState } = getAnalyticsSlice.actions;
export const getAnalyticsValue = (state: RootState) => state.analytics;
const getAnalyticsReducer = getAnalyticsSlice.reducer;
export default getAnalyticsReducer;
